import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Alert } from 'reactstrap';
import { Link } from 'react-router-dom';
import { CLEAR_INVITED_ORGANIZATION } from '../../../constants/ActionTypes';
export const Invitation = ({ user, dispatch }) => {
    const { t } = useTranslation();
    const clearInvitationAlert = () => {
        dispatch({ type: CLEAR_INVITED_ORGANIZATION });
    };
    const alertWrap = (content, type = 'primary') => {
        return (_jsx(Alert, { color: type, className: "mt-2 mb-0", toggle: clearInvitationAlert, children: content }));
    };
    if (user.invitedOrganization.organization) {
        const organizationName = user.invitedOrganization.organization.name;
        if (user.invitedOrganization.alreadyPart) {
            const link = `/settings/organizations/${encodeURI(organizationName)}`;
            return alertWrap(_jsxs(_Fragment, { children: [t('partOf'), _jsx(Link, { to: link, children: _jsxs("strong", { children: [" ", organizationName, " "] }) }), t('organization'), "."] }));
        }
        const invitedUsers = user.invitedOrganization.organization.users;
        const [owner] = invitedUsers.filter((orgUser) => orgUser.isOwner);
        const organizationOwner = owner.displayName || owner.username;
        const addedToOrganizationValues = {
            userName: user.user.displayName || user.user.username,
            siteName: t('siteName'),
            organizationOwner: organizationOwner,
            organizationName: organizationName,
        };
        return alertWrap(_jsxs(Trans, { i18nKey: "addedToOrganization", values: addedToOrganizationValues, children: ["Hi ", addedToOrganizationValues.userName, ", welcome to ", addedToOrganizationValues.siteName, ".", _jsxs("strong", { children: [" ", organizationOwner, " "] }), "added you to the", _jsxs("strong", { children: [" ", organizationName, " "] }), "organization."] }));
    }
    return alertWrap(t('yourInvitationExpired'), 'danger');
};
